export * from "./global-config";
